import { assignmentListAction } from '../../../reducers/assignment/action'
import grupActions from './grup-actions'
import columns from './columns'
import filters from './filters'
import filterModel from './filters/model'

const list = {
  searchOperation: (query, dispatch, initialData) => {
    dispatch(assignmentListAction({ ...query, SortingColumn: 'LastModifiedAt' }))
  },
  grupActions: grupActions,
  search: null,
  filters: filters,
  filtersModel: filterModel,
  row: {
    columns: columns,
    childDisableControl: row => {
      return true
    },
    childVisibleControl: row => {
      return true
    },
  },
}

export default list
